export const formatPracticeRaceName = (raceName: string | undefined, includePracticeRaces: boolean) => {
    if (!raceName || !includePracticeRaces) return raceName || '';

    // Match:
    // - \b = word boundary (ensures P/p is standalone)
    // - [Pp] = P or p
    // - (?=\s|\d|$) = positive lookahead for space, digit, OR end of string
    const practicePattern = /\b[Pp](?=\s|\d|$)/g;

    return raceName.replace(practicePattern, 'Practice');
};